<template>
  <v-container>
    <v-row
      v-for="(item, i) in coreCard.items"
      :key="i"
      dense
      @click.stop="
        $router.push({
          path: `/reporting/${report}/${reportFilter}/${item.id}`
        })
      "
    >
      <v-col class="font-weight-medium" cols="auto">
        {{ item.name }}
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="font-weight-medium">
        <v-icon v-if="value(item) == defaultScore" color="lighttext" small>
          remove
        </v-icon>
        <template v-else>
          {{ value(item) }}
        </template>
      </v-col>
      <v-col cols="12">
        <v-progress-linear
          class="rounded-sm"
          :value="slider_value(item)"
          background-color="background"
          :color="color(item)"
          height="8"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CoreCardItems",
  props: {
    coreCard: { type: Object },
    report: { type: String },
    identifier: { type: Object }
  },
  computed: {
    defaultScore() {
      return this.coreCard.type == this.$enums.coreCardTypes.ENPS ? -100 : 0;
    },
    color() {
      return item => {
        switch (this.coreCard.type) {
          case this.$enums.coreCardTypes.ENGAGEMENT:
            return this.$coreScores.getColor(
              this.$coreScores.reverseFormat(item.percentComplete)
            );
          case this.$enums.coreCardTypes.OVERALL:
            return this.$coreScores.getColor(
              this.$coreScores.reverseFormat(item.value)
            );
          case this.$enums.coreCardTypes.ENPS:
            return this.$coreScores.getEnpsLabel(item.value).color;
          default:
            return this.$coreScores.getColor(item.value);
        }
      };
    },
    value() {
      return item => {
        switch (this.coreCard.type) {
          case this.$enums.coreCardTypes.ENGAGEMENT:
            return `${this.$options.filters.no_decimal(item.percentComplete)}%`;
          case this.$enums.coreCardTypes.OVERALL:
          case this.$enums.coreCardTypes.ENPS:
            return this.$options.filters.no_decimal(item.value);
          default:
            return this.$options.filters.one_decimal(item.value);
        }
      };
    },
    slider_value() {
      return item => {
        switch (this.coreCard.type) {
          case this.$enums.coreCardTypes.ENGAGEMENT:
            return item.percentComplete;
          case this.$enums.coreCardTypes.ENPS:
            return item.value / 2 + 50;
          case this.$enums.coreCardTypes.OVERALL:
            return item.value;
          default:
            return item.value * 10;
        }
      };
    },
    reportFilter() {
      switch (this.identifier.type) {
        case this.$enums.coreCardIdTypes.MANAGERS:
          return "members";
        case this.$enums.coreCardIdTypes.TEAMS:
          return "teams";
        case this.$enums.coreCardIdTypes.COMPANY:
          return "departments";
        default:
          return "";
      }
    }
  }
};
</script>
